<template>
  <section class="block xl:hidden">
    <div class="border-t border-secondary-light-subtle fixed shadow-lg bg-secondary-x-light bottom-0 z-50 w-full">
      <div class="flex items-stretch justify-between gap-2 w-full px-1.5 lg:px-0 py-2 lg:max-w-[840px] mx-auto">
        <IconButton
          :active="showIndex"
          icon="fa-bars-sort"
          icon-weight="fa-solid"
          text="Document Index"
          @click="toggleIndex"
        />

        <div class="flex w-full items-center justify-center border border-secondary-light-subtle rounded-md overflow-hidden p-1.5 bg-white">
          <button
            class="inline-flex items-center gap-1 !text-xs uppercase text-center font-semibold text-gray-800 ms-1.5"
            :disabled="page === 0"
            :class="page === 0 ? ['cursor-default !text-gray-300'] : ''"
            @click="page--; scrollToTop(); showIndex = false; showFilters = false;"
          >
            <i class="fa-solid fa-chevron-left" />
            <span class="leading-none">Prev</span>
          </button>

          <div class="flex-grow">
            <span class="block text-center text-xs">Page {{ page + 1 }} of {{ pages }}</span>
          </div>

          <button
            class="inline-flex items-center gap-1 text-gray-800 !text-xs uppercase text-center font-semibold me-1.5"
            :disabled="(page === pages - 1)"
            :class="(page === pages - 1) ? ['cursor-default !text-gray-300'] : ''"
            @click="page++; scrollToTop(); showIndex = false; showFilters = false;"
          >
            <span class="leading-none">Next</span>
            <i class="fa-solid fa-chevron-right leading-none" />
          </button>
        </div>

        <IconButton
          :active="showFilters"
          icon="fa-filter"
          icon-weight="fa-regular"
          text="Document Filters"
          @click="toggleFilters"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import { IconButton } from '@/components/buttons/index.js';

defineProps({
  pages: {
    type: Number,
    default: 0,
  },
});

const page = defineModel('page', { type: Number, default: 1 });
const showIndex = defineModel('showIndex', { type: Boolean });
const showFilters = defineModel('showFilters', { type: Boolean });

const toggleIndex = () => {
  showIndex.value = !showIndex.value;

  if (showFilters.value) {
    showFilters.value = false;
  }
};

const toggleFilters = () => {
  showFilters.value = !showFilters.value;

  if (showIndex.value) {
    showIndex.value = false;
  }
};

const scrollToTop = () => {
  window.scrollTo(0, 0);
};
</script>
